



















import {Component, Vue} from 'vue-property-decorator'

import {Clock} from '@/icons'

@Component({
  components: {
    Clock
  }
})
export default class Investigation extends Vue {
}
